import React, {useEffect} from "react";
import { createAndResizeCircImgDivs } from '../scripts/resizer';
import seeMore from "../assets/images/see-more.png";
import icon1 from "../assets/images/1_Intro/intro_choice_moment_icon1.svg";
import icon2 from "../assets/images/1_Intro/intro_choice_moment_icon2.svg";
import icon3 from "../assets/images/1_Intro/intro_choice_moment_icon3.svg";
import Modal from "./Modal";

const MeetMoment = ( {handleOpenModal, handleCloseModal} ) => {

    useEffect(() => {
        createAndResizeCircImgDivs();
    }, []);

    const modalShowing = React.useRef(false);
    
    const handleOpenModalWithState = (modalId) => {
        handleOpenModal(modalId);
        modalShowing.current = true;
        document.querySelector("body").classList.add("hdr-modal-showing");
    };

    const handleCloseModalWithState = (modalId) => {
        handleCloseModal(modalId);
        modalShowing.current = false;
        document.querySelector("body").classList.remove("hdr-modal-showing");
    };

    const scrollToSection = (event) => {
        event.preventDefault();
        const targetId = event.currentTarget.getAttribute("href").substring(1);
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
            window.scrollTo({
                top: targetElement.offsetTop,
                behavior: "smooth",
            duration: 800,
            });
        }
    };

    return (
        <div className="row" id="meet-moment">
            <h3>The MTA is ready to meet this moment</h3>

            <p className="p3">The integration of all capital work under the MTA's Construction & Development (MTA C&D) agency is enabling projects to be delivered more effectively and quickly, beginning with the historic $55 billion 2020-2024 Capital Program. In 2022, MTA C&D completed $6.2 billion of work and initiated another $11.4 billion in new projects&mdash;delivering a historic level of investment into keeping our system in a state of good repair.</p>

            <p className="p3"><a className="hdr-launch-modal plus-sign blue" href="#more-info-intro-meet" rel="noreferrer" onClick={() => handleOpenModalWithState("more-info-intro-meet")}>Explore how MTA C&D is delivering projects better, faster, and cheaper</a></p>
            <Modal 
            id="more-info-intro-meet"
            imageSrc="https://imagedelivery.net/kzmnnJ873EMh0gbgIGnXTA/5a077403-088a-4a44-8748-70b6d8738100/width=2000"
            title="How the MTA is addressing New York's high construction costs" 
            onClose={() => handleCloseModalWithState("more-info-intro-meet")}
            content={(<><div className="hdr-modal-body">
                            <div className="row">
                                <div className="col-sm-4">
                                    <img src={icon1} className="icon-size" alt="" aria-hidden="true" />
                                    <h3>Better</h3>
                                    <p>Under a unified agency, we can improve at scale&mdash;from implementing delivery models that take advantage of design innovation, to instituting smarter project management, to modernizing our approach to signals and systems. This has led to the completion of major projects&mdash;from 10 miles of Third Track, to repair of the <span className="metro-line line-l">L</span> Train Tunnel, to transformation of the LIRR Concourse at Penn Station&mdash;all on time and on or under budget.</p>
                                </div>
                                <div className="col-sm-4">
                                    <img src={icon2} className="icon-size" alt="" aria-hidden="true" />
                                    <h3>Faster</h3>
                                    <p>We have ramped up the pace of our investment to a historic level&mdash;including more than doubling the number of stations accessible under the Americans with Disabilities Act (ADA) in this capital program compared to previous years. We are also getting projects done faster, with our innovative contracting incentives saving an average of four months compared to the estimated schedule in 2022.</p>
                                </div>
                                <div className="col-sm-4">
                                    <img src={icon3} className="icon-size" alt="" aria-hidden="true" />
                                    <h3>Cheaper</h3>
                                    <p>New York's density, high wages, significant ridership, and complicated logistics all mean that the region is inherently high-cost. Nevertheless, we deliver our state-of-good-repair projects, more than 80% of our capital plan, at costs on par with peers across the country. With a heightened focus on cost containment, our construction contracts came in $345 million under estimate in 2022.</p>
                                    <a href="documents/Intro_ReducingCosts.pdf" target="_blank">See how we're committed to reducing costs</a>

                                </div>
                            </div>
                            <br />
                            <div className="row">
                                <h3>Structural reforms</h3>
                                <p>In 2019, we an independent forensic audit of its capital planning process. Performed by Crowe, a leading accounting firm, the audit assessed the performance of the MTA's capital program development processes, specifically evaluating project selection for the five-year capital plan. The recommendations of that audit are being implemented rapidly, highlighted by:</p>
                                <ul>
                                    <li><strong>A unified planning approach:</strong> With the creation of MTA Construction & Development, capital planning, development, and delivery are being undertaken by a single, purpose-built capital agency.</li>
                                    <li><strong>A focus on state of good repair:</strong> Despite these factors, costs for MTA's state-of-good-repair projects, more than 80% of the current capital plan, are largely in line with peer systems across the country. While recent subway expansion projects have high price tags, they are highly cost-beneficial with low cost per rider.</li>
                                    <li><strong>A smarter approach to data:</strong> As the audit recommended, the MTA has undertaken a thorough effort to modernize and standardize its data collection, establishing detailed inventories of all assets, including asset age and surveyed condition and integrated Enterprise Asset Management (EAM) where possible. As part of the assessment, we incorporated additional essential metrics including performance, criticality, parts obsolescence, and compatibility with modern systems.</li>
                                </ul>
                            </div>
                        </div>
                    </>)} />

            <blockquote>The 20-Year Needs Assessment provides the path toward a resilient, reliable, and modern transit system that is safer and more efficient. These investments will unlock a new generation of prosperity for the region.</blockquote>

            <a href="#our-vision" onClick={scrollToSection} style={{ display: "block", margin: "48px 0 0", textAlign: "center", textDecoration: "none" }}>
                <span>See how</span>
                <img src={seeMore} alt="" aria-hidden="true" style={{ display: "block", height: "62px", margin: "12px auto 0", position: "relative", top: 0, transition: "top .3s" }}/>
            </a>
        </div>
    );
};

export default MeetMoment;